import { makePath } from '@feedyou/utils'
import { DialogStepSchema } from '@feedyou-ai/feedbot-schema'

import { getUsedDialogs } from './getUsedDialogs'
import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<DialogStepSchema> = (
  step,
  parentDialogId
) => {
  return [...getUsedDialogs(step)].map(dialog => {
    return {
      parentDialog: parentDialogId,
      childDialog: dialog,
      checkpointLink: makePath(step.id)
    }
  })
}
